import { render, staticRenderFns } from "./SelectPackage.vue?vue&type=template&id=5a82a7f2"
import script from "./SelectPackage.vue?vue&type=script&lang=ts"
export * from "./SelectPackage.vue?vue&type=script&lang=ts"
import style0 from "./SelectPackage.vue?vue&type=style&index=0&id=5a82a7f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports